import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";

const Privacy: React.FC = () => {
  return (
    <Box
      component="main"
      sx={{
        py: 12,
        minHeight: "calc(100vh - 64px)",
        backgroundColor: "background.default",
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 6 },
            borderRadius: 2,
            backgroundColor: "background.paper",
          }}
        >
          <Typography variant="h1" sx={{ fontSize: "2.5rem", mb: 4 }}>
            Datenschutzerklärung und Haftungsausschluss
          </Typography>

          {/* 1. Haftungsausschluss – Disclaimer */}
          <Typography variant="h2" sx={{ fontSize: "1.5rem", mb: 2, mt: 4 }}>
            1. Haftungsausschluss – Disclaimer
          </Typography>
          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Haftung für Inhalte
          </Typography>
          <Typography paragraph>
            Alle Inhalte unseres Internetauftritts von pyzon wurden mit größter
            Sorgfalt und nach bestem Gewissen erstellt. Für die Richtigkeit,
            Vollständigkeit und Aktualität der Inhalte können wir jedoch keine
            Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG
            für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
            verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
            jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
            Informationen zu überwachen oder nach Umständen zu forschen, die auf
            eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur
            Entfernung oder Sperrung der Nutzung von Informationen bleiben
            hiervon unberührt. Eine Haftung tritt erst ab dem Zeitpunkt ein, ab
            dem uns konkrete Rechtsverletzungen bekannt werden. Bei
            Bekanntwerden von solchen Rechtsverletzungen entfernen wir die
            entsprechenden Inhalte unverzüglich.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Haftungsbeschränkung für externe Links
          </Typography>
          <Typography paragraph>
            Unsere Webseite enthält Links auf externe Webseiten Dritter. Da wir
            keinen Einfluss auf die Inhalte dieser Webseiten haben, können wir
            für deren Richtigkeit oder Vollständigkeit keine Gewähr übernehmen.
            Zum Zeitpunkt der Linksetzung waren keine Rechtsverstöße erkennbar.
            Eine fortlaufende Überprüfung der externen Links ist jedoch ohne
            konkrete Hinweise auf Rechtsverletzungen nicht zumutbar. Sobald uns
            rechtswidrige Inhalte auffallen, werden wir die entsprechenden Links
            umgehend entfernen.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Urheberrecht
          </Typography>
          <Typography paragraph>
            Die auf unserer Webseite veröffentlichten Inhalte und Werke
            unterliegen dem deutschen Urheberrecht. Jede Vervielfältigung,
            Bearbeitung, Verbreitung oder andere Nutzung der Inhalte bedarf der
            vorherigen schriftlichen Zustimmung des jeweiligen Urhebers.
            Downloads und Kopien dieser Seite sind nur für den privaten und
            nicht kommerziellen Gebrauch gestattet. Sollten Inhalte Dritter auf
            unserer Website vorhanden sein, werden diese als solche
            gekennzeichnet. Bei Bekanntwerden von Urheberrechtsverletzungen
            werden wir die betroffenen Inhalte unverzüglich entfernen.
          </Typography>

          {/* 2. Datenschutzerklärung */}
          <Typography variant="h2" sx={{ fontSize: "1.5rem", mb: 2, mt: 4 }}>
            2. Datenschutzerklärung
          </Typography>
          <Typography paragraph>
            Wir freuen uns über Ihr Interesse an pyzon. Der Schutz Ihrer
            persönlichen Daten hat für uns einen besonders hohen Stellenwert.
            Die Nutzung unserer Internetseiten ist grundsätzlich ohne die Angabe
            personenbezogener Daten möglich. Sollte der Fall eintreten, dass
            besondere Leistungen genutzt werden, erfordert dies ggf. die
            Verarbeitung personenbezogener Daten. In solchen Fällen holen wir –
            soweit keine gesetzliche Grundlage besteht – stets eine Einwilligung
            der betroffenen Person ein.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Begriffsbestimmungen
          </Typography>
          <Typography paragraph>
            In dieser Datenschutzerklärung verwenden wir die Begrifflichkeiten
            der Datenschutz-Grundverordnung (DS‑GVO). Personenbezogene Daten
            sind alle Informationen, die sich auf eine identifizierte oder
            identifizierbare natürliche Person beziehen. Eine betroffene Person
            ist jede identifizierte oder identifizierbare natürliche Person,
            deren Daten verarbeitet werden. Verarbeitung umfasst jeden Vorgang
            im Zusammenhang mit personenbezogenen Daten, wie Erhebung,
            Speicherung, Nutzung, Übermittlung und Löschung.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Name und Anschrift des für die Verarbeitung Verantwortlichen
          </Typography>
          <Typography paragraph>
            Verantwortlicher im Sinne der DS‑GVO und anderer
            datenschutzrechtlicher Bestimmungen ist:
            <br />
            <br />
            pyzon – Patrick Hutter
            <br />
            Soderstraße 51
            <br />
            64287 Darmstadt
            <br />
            Deutschland
            <br />
            E-Mail: info@pyzon.de
            <br />
            Website: www.pyzon.de
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Cookies
          </Typography>
          <Typography paragraph>
            Unsere Internetseiten verwenden Cookies. Cookies sind kleine
            Textdateien, die auf Ihrem Endgerät gespeichert werden, um eine
            Analyse der Benutzung der Website zu ermöglichen. Die meisten
            Browser akzeptieren Cookies automatisch. Sie können Ihre
            Browser-Einstellungen anpassen, um Cookies zu löschen oder deren
            Speicherung zu verhindern.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Google Analytics
          </Typography>
          <Typography paragraph>
            Diese Website nutzt Google Analytics, einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland ("Google"). Google Analytics verwendet Cookies, die auf Ihrem Gerät gespeichert werden und die eine Analyse der Benutzung der Website ermöglichen.
          </Typography>
          <Typography paragraph>
            Die durch das Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Wir haben die IP-Anonymisierung aktiviert, sodass Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt wird. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt.
          </Typography>
          <Typography paragraph>
            Google wird diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt.
          </Typography>
          <Typography paragraph>
            Sie können die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie in unseren Cookie-Einstellungen die entsprechende Option deaktivieren oder das Browser-Plugin zur Deaktivierung von Google Analytics herunterladen und installieren: <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noopener noreferrer">https://tools.google.com/dlpage/gaoptout?hl=de</a>.
          </Typography>
          <Typography paragraph>
            Wir nutzen Google Analytics, um die Nutzung unserer Website zu analysieren und regelmäßig zu verbessern. Die gewonnenen Statistiken ermöglichen es uns, unser Angebot zu verbessern und für Sie als Nutzer interessanter zu gestalten. Die Rechtsgrundlage für die Nutzung von Google Analytics ist Art. 6 Abs. 1 S. 1 lit. a DSGVO (Ihre Einwilligung).
          </Typography>
          <Typography paragraph>
            Weitere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter <a href="https://marketingplatform.google.com/about/analytics/terms/de/" target="_blank" rel="noopener noreferrer">https://marketingplatform.google.com/about/analytics/terms/de/</a> und <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy?hl=de</a>.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Erfassung von allgemeinen Daten und Informationen
          </Typography>
          <Typography paragraph>
            Bei jedem Zugriff auf unsere Website werden automatisch
            Informationen in den Server-Logfiles gespeichert, wie etwa der
            Browsertyp, das Betriebssystem, die IP-Adresse, Datum und Uhrzeit
            des Zugriffs. Diese Daten dienen statistischen Zwecken und der
            Optimierung der Website – eine direkte Zuordnung zu einer bestimmten
            Person erfolgt nicht.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Kontaktmöglichkeit über die Internetseite
          </Typography>
          <Typography paragraph>
            Unsere Website enthält verschiedene Möglichkeiten der
            Kontaktaufnahme, z.B. über ein Kontaktformular oder per E-Mail an
            info@pyzon.de. Die hierüber übermittelten Daten werden
            ausschließlich zur Bearbeitung Ihrer Anfrage verwendet und nicht an
            Dritte weitergegeben.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Routinemäßige Löschung und Sperrung von personenbezogenen Daten
          </Typography>
          <Typography paragraph>
            Personenbezogene Daten speichern wir nur so lange, wie es für den
            jeweiligen Zweck erforderlich ist oder gesetzliche
            Aufbewahrungsfristen es vorsehen. Anschließend werden die Daten
            routinemäßig gelöscht oder gesperrt.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Rechte der betroffenen Person
          </Typography>
          <Typography paragraph>
            Als betroffene Person haben Sie jederzeit das Recht auf Auskunft
            über die bei uns gespeicherten Daten. Zudem stehen Ihnen das Recht
            auf Berichtigung, Löschung, Einschränkung der Verarbeitung und
            Datenübertragbarkeit zu. Außerdem können Sie der Verarbeitung
            widersprechen. Zur Ausübung dieser Rechte wenden Sie sich bitte an
            info@pyzon.de.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Datenschutz bei Bewerbungen
          </Typography>
          <Typography paragraph>
            Im Rahmen von Bewerbungsverfahren verarbeiten wir die von Ihnen
            eingesandten Daten ausschließlich zum Zwecke der Durchführung des
            Bewerbungsverfahrens. Sollten keine Verträge zustande kommen, werden
            die Bewerbungsunterlagen nach Ablauf einer angemessenen Frist
            gelöscht.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Rechtsgrundlage der Verarbeitung
          </Typography>
          <Typography paragraph>
            Die Verarbeitung personenbezogener Daten erfolgt auf Grundlage von
            Art. 6 I lit. a–f DS‑GVO, sofern keine gesetzlichen Vorgaben
            entgegenstehen. Für vertragliche Zwecke, etwa zur Lieferung von
            Waren oder zur Erbringung von Dienstleistungen, beruht die
            Verarbeitung auf Art. 6 I lit. b DS‑GVO.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Berechtigte Interessen
          </Typography>
          <Typography paragraph>
            Unsere berechtigten Interessen an der Datenverarbeitung ergeben sich
            aus der Durchführung unserer Geschäftstätigkeit sowie der
            Optimierung und Sicherstellung eines reibungslosen Onlineauftritts.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Dauer der Speicherung
          </Typography>
          <Typography paragraph>
            Die Dauer der Speicherung Ihrer personenbezogenen Daten richtet sich
            nach den gesetzlichen Aufbewahrungsfristen. Nach Ablauf dieser
            Fristen werden die Daten routinemäßig gelöscht.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Gesetzliche oder vertragliche Vorschriften
          </Typography>
          <Typography paragraph>
            Die Bereitstellung personenbezogener Daten kann gesetzlich
            vorgeschrieben sein oder sich aus vertraglichen Regelungen ergeben.
            Die Nichtbereitstellung der Daten kann zur Folge haben, dass ein
            Vertrag nicht zustande kommt.
          </Typography>

          <Typography variant="h3" sx={{ fontSize: "1.2rem", mb: 1, mt: 3 }}>
            Automatisierte Entscheidungsfindung
          </Typography>
          <Typography paragraph>
            Wir verzichten auf eine ausschließliche automatisierte
            Entscheidungsfindung beziehungsweise auf ein reines Profiling im
            Sinne der DS‑GVO.
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
            Stand: April 2025
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Privacy;
